import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import GivingChallenges from './pages/giving-challenges';
import LoginPage from './pages/login';
import CompanyRegister from './pages/company-register';
import CommunityFeed from './pages/community-feed';
import CharityProfile from './pages/charity-profile';
import UserDashboard from './pages/user-dashboard';
import CauseDiscovery from './pages/cause-discovery';
import Register from './pages/register';
import Homepage from './pages/homepage';
import LandingPage from './pages/landing-page';
import OrganizationDashboard from './pages/organization-dashboard';
import AboutPage from './pages/about';
import ContactPage from './pages/contact';
import BusinessESG from './pages/business-esg';
import RegistrationConfirmation from './pages/registration-confirmation';
import PasswordRecovery from './pages/password-recovery';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/giving-challenges" element={<GivingChallenges />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/company-register" element={<CompanyRegister />} />
        <Route path="/community-feed" element={<CommunityFeed />} />
        <Route path="/charity-profile" element={<CharityProfile />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/cause-discovery" element={<CauseDiscovery />} />
        <Route path="/register" element={<Register />} />
        <Route path="/registration-confirmation" element={<RegistrationConfirmation />} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />
        <Route path="/organization-dashboard" element={<OrganizationDashboard />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/business-esg" element={<BusinessESG />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;